import { Formik } from "formik";
import { FC, createContext } from "react";
import TableOrganization from "./components/TableOrganization";

export interface OrganizationPageContextProps {}

interface IProps {}

const initialContext = {};

export const OrganizationPageContext =
  createContext<OrganizationPageContextProps>(initialContext);

export const OrganizationPage: FC<IProps> = (props) => {
  return (
    <Formik<any> initialValues={{}} onSubmit={() => {}}>
      <OrganizationPageContext.Provider value={{}}>
        <div className="bg-white">
          <div className="flex-1 flex flex-column">
            <div className="py-1 ">
              <TableOrganization />
            </div>
          </div>
        </div>
      </OrganizationPageContext.Provider>
    </Formik>
  );
};

export default OrganizationPage;
